export default __webpack_public_path__ + "static/media/rewards-brand.9dbba571.png";